import { useState } from 'react';
import { AccountModel, Group, HanThanhToan, KhuVuc, NhanVien, NhaCungCap, PhuongThucThanhToan } from '@/types/schemas';

export interface FormState {
  nhanVien: NhanVien | null;
  taiKhoanNgamDinh: AccountModel | null;
  thanhToan: HanThanhToan | null;
  phuongThucThanhToan: PhuongThucThanhToan | null;
  nhom1: Group | null;
  nhom2: Group | null;
  nhom3: Group | null;
  khuVuc: KhuVuc | null;
}

export interface FormActions {
  setNhanVien: (nhanVien: NhanVien) => void;
  setTaiKhoanNgamDinh: (taiKhoanNgamDinh: AccountModel) => void;
  setThanhToan: (thanhToan: HanThanhToan) => void;
  setPhuongThucThanhToan: (phuongThucThanhToan: PhuongThucThanhToan) => void;
  setNhom1: (nhom1: Group) => void;
  setNhom2: (nhom2: Group) => void;
  setNhom3: (nhom3: Group) => void;
  setKhuVuc: (khuVuc: KhuVuc) => void;
  resetState: () => void;
  updateState: (updates: Partial<FormState>) => void;
}

export interface UseFormStateReturn {
  state: FormState;
  actions: FormActions;
}

const initialState: FormState = {
  nhanVien: null,
  taiKhoanNgamDinh: null,
  thanhToan: null,
  phuongThucThanhToan: null,
  nhom1: null,
  nhom2: null,
  nhom3: null,
  khuVuc: null
};

function transformInitialData(initialData?: NhaCungCap): Partial<FormState> {
  if (!initialData) return {};

  return {
    nhanVien: initialData.sales_rep_data || null,
    taiKhoanNgamDinh: initialData.account_data || null,
    thanhToan: initialData.payment_term_data || null,
    phuongThucThanhToan: initialData.payment_method_data || null,
    nhom1: initialData.customer_group1_data || null,
    nhom2: initialData.customer_group2_data || null,
    nhom3: initialData.customer_group3_data || null,
    khuVuc: initialData.region_data || null
  };
}

export function useFormState(initialData?: NhaCungCap): UseFormStateReturn {
  const [state, setState] = useState<FormState>({
    ...initialState,
    ...transformInitialData(initialData)
  });

  const actions: FormActions = {
    setNhanVien: (nhanVien: NhanVien) => {
      setState(prev => ({ ...prev, nhanVien: nhanVien }));
    },

    setTaiKhoanNgamDinh: (taiKhoanNgamDinh: AccountModel) => {
      setState(prev => ({ ...prev, taiKhoanNgamDinh: taiKhoanNgamDinh }));
    },

    setThanhToan: (thanhToan: HanThanhToan) => {
      setState(prev => ({ ...prev, thanhToan: thanhToan }));
    },

    setPhuongThucThanhToan: (phuongThucThanhToan: PhuongThucThanhToan) => {
      setState(prev => ({ ...prev, phuongThucThanhToan: phuongThucThanhToan }));
    },

    setNhom1: (nhom1: Group) => {
      setState(prev => ({ ...prev, nhom1: nhom1 }));
    },

    setNhom2: (nhom2: Group) => {
      setState(prev => ({ ...prev, nhom2: nhom2 }));
    },

    setNhom3: (nhom3: Group) => {
      setState(prev => ({ ...prev, nhom3: nhom3 }));
    },

    setKhuVuc: (khuVuc: KhuVuc) => {
      setState(prev => ({ ...prev, khuVuc: khuVuc }));
    },

    resetState: () => {
      setState(initialState);
    },

    updateState: (updates: Partial<FormState>) => {
      setState(prev => ({ ...prev, ...updates }));
    }
  };

  return { state, actions };
}
